import { _js } from '@ifixit/utils/localize';
import { toast } from '@ifixit/ui/components/toast';

onDomReady(() => {
   let map = new google.maps.Map($('map'), {
      center: new google.maps.LatLng(39.5, -92),
      zoom: 3,
      streetViewControl: false,
      scrollwheel: false,
      styles: [
         {
            stylers: [{ saturation: -100 }],
         },
         {
            featureType: 'water',
            stylers: [{ invert_lightness: true }, { lightness: 10 }],
         },
      ],
   });

   let layer = new google.maps.KmlLayer({
      url: App.kmlUrl,
      preserveViewport: true,
      styles: [
         {
            markerOptions: {
               iconName: 'small_green',
            },
         },
      ],
      map: map,
   });

   let pledgeUpdateCount = function () {
      let count = $('pledge-select-count').value;
      if (count == '1') {
         $$('.pledge-when-all').hide();
         $$('.pledge-when-greater-than-1').hide();
         $$('.pledge-when-1').show('inline');
      } else if (count == 'all') {
         $$('.pledge-when-all').show('inline');
         $$('.pledge-when-1').hide();
         $$('.pledge-when-greater-than-1').hide();
      } else {
         $$('.pledge-when-all').hide();
         $$('.pledge-when-greater-than-1').show('inline');
         $$('.pledge-when-1').hide();
      }
   };

   pledgeUpdateCount();
   $('pledge-select-count').addEvent('change', pledgeUpdateCount);

   $('pledge-form').addEvent('submit', ev => {
      ev.stop();

      if ($('name').validity.valid) {
         const pledgeToastId = toast.loading('Pledging!');

         new Request.AjaxIO('submitPledge', {
            onSuccess: result => pledgeSubmitted(result, pledgeToastId),
            onError: () => toast.error(_js('Something went wrong.'), { id: pledgeToastId }),
         }).send($('name').value, $('email').value, $('pledge-select-count').value);
      } else {
         toast.error('Name must be at least three characters.');
         return;
      }
   });

   function plotPointOnMap(latitude, longitude) {
      // TODO: This is a vastly different marker style than the fusion table
      // layer. Maybe reloading the fusion table and zooming in on the user's
      // location would be good? Or not displaying a marker at all?
      new google.maps.Marker({
         position: new google.maps.LatLng(latitude, longitude),
         map: map,
         title: 'You!',
         icon: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png',
      });
   }

   function pledgeSubmitted(result, pledgeToastId) {
      $('pledgeDiv').scrollIntoView({ behavior: 'smooth' });
      toast.dismiss(pledgeToastId);
      plotPointOnMap(result.latitude, result.longitude);
      $$('.pledge-count').set('text', result.pledgeNumber);

      $$('.pledge-form').hide();

      let submittedElements = $$('.pledge-submitted');
      submittedElements.removeClass('pledge-submitted');
   }
});
